import React, {Component} from "react";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List, Map} from "immutable";
import {graphql} from "react-apollo";
import {GET_ORDER_WITH_PRODUCTS} from "../../queries/sales";
import Address from "../../shipping/controls/Address";
import TrackingList from "../../shipping/views/TrackingList";
import ProductTable from "../../customers/shared/ProductTable";
import "./OrderDetails.css";

class OrderDetails extends Component {

  render() {
    let {loading, error} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />        
    const order = fromJS(this.props.data.salesOrder);

    return (
      <div className="OrderDetails">
        <div className="addresses section">
          <h4>Ship to</h4>
          <Address label="Ship To" address={order.getIn(["shipping", 0, "deliveryAddress"], Map())} />
        </div>        
        <div className="products section">
          <h4>Products in Order</h4>
          <ProductTable
            products={order.get("products")}
            subscriptionFrequencyWeeks={order.get("subscriptionFrequencyWeeks")}
            showSubtotal={false}
            />
        </div>        
        {this.renderTrackingList(order.get("shipping"))}
      </div>
    )
  }

  renderTrackingList(order) {
    if (!List(["dispatch", "in_transit", "delivered", "partially_delivered", "voided", "failed"]).includes(order.get("fulfillmentStatus"))) {
      return null;
    }

    return (
      <div className="tracking section">
        <h4>Package Tracking</h4>
        <TrackingList
          courierId={order.get("courierId")}
          orderId={order.get("orderId")}
          />
      </div>
    )
  }

}

const withQuery = graphql(GET_ORDER_WITH_PRODUCTS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      orderId: props.orderId
    }
  })
})


export default withQuery(OrderDetails);